import { jsx as _jsx } from "react/jsx-runtime";
import { useContactContext } from "@/contexts/contact";
import { DisplayPhoneNumbersButton } from "./DisplayPhoneNumbersButton";
import { CallButton } from "./CallButton";
import { useI18n } from "@/shared/hooks";
export const PhoneButtonContainer = ({ tracking, iconOnly = false, }) => {
    const { phoneNumbers } = useContactContext();
    const { t } = useI18n();
    const buttonLabel = t("contact.mobile_sticky.phone");
    if (phoneNumbers.length === 0) {
        return null;
    }
    if (phoneNumbers.length === 1) {
        return (_jsx(CallButton, { phoneNumber: phoneNumbers[0], label: buttonLabel, tracking: tracking, iconOnly: iconOnly }));
    }
    return (_jsx(DisplayPhoneNumbersButton, { phoneNumbers: phoneNumbers, label: buttonLabel, tracking: tracking, iconOnly: iconOnly }));
};
